import { useQuery } from "@tanstack/react-query"
import { getTrackingDetails } from "@/lib/api/order.api"

export function useGetTrackingDetails(url?: string, trackingId?: string) {
  return useQuery({
    queryKey: ["shipment-tracking", url, trackingId],
    queryFn: () => {
      if (!url || !trackingId) throw new Error("Missing parameters")
      return getTrackingDetails(url, trackingId)
    },
    enabled: !!url && !!trackingId,
    staleTime:0,
    retry: 1,
  })
}
